import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OnboardingAccount } from 'se-resource-types/dist/lib/Clare';

import { environment } from 'src/environments/environment';
import { ApiResponse } from '../shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class PayoutAccountService {
  constructor(public httpClient: HttpClient) { }

  protected static getShowUri(orgId: string | number): string {
    return environment.apiUrl + `onboarding/accounts/organization:${orgId}`;
  }

  private static getOptions(params?: object): object {
    return {
      params: params,
      withCredentials: true,
      headers: {
        Accept: 'application/json'
      }
    };
  }

  getPayoutAccount(
    orgId: string | number,
    accountId?: string | number
  ): Observable<ApiResponse<OnboardingAccount>> {
    const params = accountId != null ? { account_id: accountId } : undefined;
    return this.httpClient.get<ApiResponse<OnboardingAccount>>(
      PayoutAccountService.getShowUri(orgId),
      PayoutAccountService.getOptions(params)
    );
  }
}
